import { simpleSet } from '@r/reducers/utils';

const setCalculationModeShippingAddress = simpleSet as
  redux.reducers.calculationMode.settings.information.shippingAddress;

export const shippingAddress = setCalculationModeShippingAddress(
  'SET_CALCULATION_MODE_SHIPPING_ADDRESS',
  ''
);
